// import axios from 'axios';
import http from './http';

// 获取 DMS 埋点配置文件
// export const fetchTelescopeCode = () => {
//   return axios.get('https://static.91jkys.com/dms/56ddf590457bc1c8c5e2febd8d0a07c2.json').then(res => {
//     return res.data;
//   });
// };

export const receiveCouponByIdPost = params => {
  const url = 'cmall-coupon/1.0.0/receiveCouponById';
  return http({
    url,
    method: 'Post',
    params
  });
};

export const couponListByIdsPost = params => {
  const url = 'cmall-coupon/1.0.0/couponListByIds';
  return http({
    url,
    method: 'Post',
    params
  });
};

export const batchQuerySimpleItemInfoPost = params => {
  const url = 'cmall-item/1.0.0/batchQuerySimpleItemInfo';
  return http({
    url,
    method: 'Post',
    params
  });
};

export const couponListByIdsAndUserPost = params => {
  const url = 'cmall-coupon/1.0.0/couponListByIdsAndUser';
  return http({
    url,
    method: 'Post',
    params
  });
};

export const queryReceiveStatusGet = params => {
  const url = 'invitee_customer_api/1.0/queryReceiveStatus';
  return http({
    url,
    method: 'Get',
    params
  });
};

export const receiveAwardRequestPost = params => {
  const url = 'invitee_customer_api/1.0/receiveAwardRequest';
  return http({
    url,
    method: 'Post',
    params
  });
};

export const queryReceiveAwardGet = params => {
  const url = 'invitee_customer_api/1.0/queryReceiveAward';
  return http({
    url,
    method: 'Get',
    params
  });
};

export const getNearShopsByUserLocationPost = params => {
  const url = 'cmall-shop/1.0.0/getNearShopsByUserLocation';
  return http({
    url,
    method: 'Post',
    params
  });
};

export const listUserAddressGet = params => {
  const url = 'cmall-address/1.0/listUserAddress';
  return http({
    url,
    method: 'Get',
    params
  });
};
